// src/components/DataTable.js
import React, { useState } from "react";
import {
  IconBold,
  IconPlus,
} from "@tabler/icons-react";
import { NavLink } from "react-router-dom";

const DataTable = ({ title, newButtonRoute, data }) => {
  const [search, setSearch] = useState("");
  const [entries, setEntries] = useState(8);

  const handleSearchChange = (e) => setSearch(e.target.value);
  const handleEntriesChange = (e) => setEntries(e.target.value);

  const filteredData = data.filter((item) =>
    item.subject.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h3 className="card-title">{title}</h3>
        <div className="btn-list">
          <NavLink to={newButtonRoute} className="btn btn-primary d-flex align-items-center">
            <span className="ms-1">Novo</span>
          </NavLink>
        </div>
      </div>

      <div className="card-body border-bottom py-3">
        <div className="d-flex">
          <div className="text-secondary">
            Mostrar
            <div className="mx-2 d-inline-block">
              <input
                type="text"
                className="form-control form-control-sm"
                value={entries}
                onChange={handleEntriesChange}
                size="3"
                aria-label="Invoices count"
              />
            </div>
            registros
          </div>
          <div className="ms-auto text-secondary">
            Procurar:
            <div className="ms-2 d-inline-block">
              <input
                type="text"
                className="form-control form-control-sm"
                value={search}
                onChange={handleSearchChange}
                aria-label="Procurar"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table card-table table-vcenter text-nowrap datatable">
          <thead>
            <tr>
              <th className="w-1">
                <input
                  className="form-check-input m-0 align-middle"
                  type="checkbox"
                  aria-label="Select all invoices"
                />
              </th>
              <th className="w-1">Nr.</th>
              <th>Instituição</th>
              <th>Responsavel</th>
              <th>SIGED Nr.</th>
              <th>Data Geração</th>
              <th>Status</th>
              <th>Solicitado</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {filteredData.slice(0, entries).map((item) => (
              <tr key={item.id}>
                <td>
                  <input
                    className="form-check-input m-0 align-middle"
                    type="checkbox"
                    aria-label="Select invoice"
                  />
                </td>
                <td><span className="text-secondary">{item.number}</span></td>
                <td><a href={item.link} className="text-reset">{item.subject}</a></td>
                <td>{item.client}</td>
                <td>{item.vat}</td>
                <td>{item.created}</td>
                <td>
                  <span className={`badge ${item.statusClass} me-1`}></span>
                  {item.status}
                </td>
                <td>{item.price}</td>
                <td className="text-end">
                  <span className="dropdown">
                    <button className="btn dropdown-toggle align-text-top" data-bs-toggle="dropdown">Ações</button>
                    <div className="dropdown-menu dropdown-menu-end">
                      <a className="dropdown-item" href="#">Ver</a>
                      <a className="dropdown-item" href="#">Editar</a>
                      <a className="dropdown-item text-red" href="#">Excluir</a>
                    </div>
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="card-footer d-flex align-items-center">
        <p className="m-0 text-secondary">
          Exibindo <span>1</span> até <span>{Math.min(entries, filteredData.length)}</span> de <span>{filteredData.length}</span> registros
        </p>
        <ul className="pagination m-0 ms-auto">
          <li className="page-item disabled">
            <a className="page-link" href="#" aria-disabled="true">ante</a>
          </li>
          {/* Pagination items */}
          <li className="page-item active">
            <a className="page-link" href="#">1</a>
          </li>
          <li className="page-item"><a className="page-link" href="#">2</a></li>
          <li className="page-item"><a className="page-link" href="#">3</a></li>
          <li className="page-item">
            <a className="page-link" href="#">prox</a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default DataTable;